import styled from 'styled-components';

export const RootContainer = styled.div`
  position: relative;
  display: ${props => props.showNav === 0 ? 'block' : 'flex'};
  //flex-direction: column;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;